import { AnnotationMarker } from '../types';

export function compileAnnotationsToPrompt(
  markers: AnnotationMarker[],
): string {
  const sortedMarkers = [...markers].sort((a, b) => a.number - b.number);

  const validMarkers = sortedMarkers.filter((m) => m.description.trim());

  if (validMarkers.length === 0) {
    return '';
  }

  const instructions = validMarkers
    .map((m) => {
      const posStr = `${m.position.x.toFixed(1)}% ${m.position.y.toFixed(1)}%`;
      return `${m.number}. [${m.label}, ${posStr}] ${m.description}`;
    })
    .join('\n');

  return `Please improve the image with the following changes:\n${instructions}`;
}
